import cn from 'classnames';
import { Dispatch, SetStateAction, memo } from 'react';
import { animated } from 'react-spring';
import {
    IJackpotPlayerObject,
    IPlayerProperties,
    IStakeObject,
    TJackpotTickets,
} from '@api/types/jackpot';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { ReactComponent as CrownIcon } from '@assets/svg/crown.svg';
import { ReactComponent as StarIcon } from '@assets/svg/star.svg';
import { BREAKPOINTS } from '@consts/ui';
import { calcChanceToWin } from '@utils/jackpot';
import { formatThousandNumber } from '@utils/utils';
import Avatar from '@components/avatar';
import CountUp from 'react-countup';
import styles from './stats.module.scss';
import useReduxState from '@hooks/useReduxState';
import useJackpotRoom from '@hooks/useJackpotRoom';

interface IDepositData {
    stake: IStakeObject;
    tickets: TJackpotTickets;
    player?: IJackpotPlayerObject;
    bank: number;
    prevStake: number;
}

export interface IPlayerDepositProps extends IPlayerProperties {
    data: IDepositData;
    setFromTickets: Dispatch<SetStateAction<number[]>>;
    style: any;
}

const PlayerDeposit = ({
    isLikelyToWin,
    isWinner,
    data: {
        stake: { stake },
        player,
        prevStake,
    },
    style,
}: IPlayerDepositProps): JSX.Element => {
    const [{ jackpot, ui }] = useReduxState((state) => state);
    const { rooms } = jackpot;
    const { currentRoom } = useJackpotRoom();
    const game = rooms[currentRoom].current_game;

    console.log('deposit', player);
    if (!player) return <></>;

    const { user } = player;

    /* Effect to update last "from" ticket */

    /* ClassNames */

    const depositClassNames = cn(styles.deposit, {
        [styles.winner]: isWinner,
    });

    const oddsClassNames = cn(styles.values__odds, {
        [styles.likelytowin]: isLikelyToWin,
    });

    /* Components */

    const DepositedAmount = (
        <p className={styles.amount}>
            <CoinIcon />
            <span>{formatThousandNumber(stake / 100)}</span>
        </p>
    );

    const Tickets = (
        <p className={styles.data__tickets}>
            Tickets from #<span>{formatThousandNumber(prevStake + 1)}</span> to
            #<span>{formatThousandNumber(prevStake + stake)}</span>
        </p>
    );

    return (
        <animated.div className={depositClassNames} style={style}>
            <div className={styles.data}>
                <Avatar
                    className={styles.data__avatar}
                    src={user.avatar_url}
                    alt={user.username}
                    width="52"
                />
                <div className={styles.data__userinfo}>
                    <p className={styles.data__username}>
                        {user.username} <span>deposited</span>
                    </p>
                    {ui.windowWidth >= BREAKPOINTS.MD && DepositedAmount}
                    {Tickets}
                </div>
            </div>
            <div className={styles.values}>
                {ui.windowWidth < BREAKPOINTS.MD && DepositedAmount}
                <p className={oddsClassNames}>
                    {isLikelyToWin && <StarIcon />}
                    <span>
                        <CountUp
                            end={calcChanceToWin({
                                bank: game.bank,
                                total_stake: stake,
                            })}
                            duration={1}
                        />
                        %
                    </span>
                </p>
            </div>

            {/* Absolute positioning icons */}

            {isWinner && <CrownIcon className={styles.crownicon} />}
        </animated.div>
    );
};

export default memo(PlayerDeposit);
